import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  InputLabel,
  makeStyles
} from "@material-ui/core";
import { bookingApi } from "functions/apis";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import { Check, MailOutline } from "@material-ui/icons";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput";
import Button from "components/CustomButtons/Button.js";
import MerchantDialog from "components/MerchantDialog/MerchantDialog";
import RichTextComponent from "./SlateFormV2";
import { deserializeHtmlString } from "functions/Helper";
import Datetime from "react-datetime";

const useStyles = makeStyles(styles);

const merchantPromoType = ["Claimable", "System Generated", "Unclaimable"];

const merchantPromoValidityType = ["Month", "Week", "Day"];

const merchantPromoGenerationEvent = ["New User", "First Booking", "Birthday"];

const usagePeriodCalculation = ["By ClaimDate", "Fixed"];

export default function RemoveBanner(props) {
  const abortSignal = useRef(new AbortController());

  const { id } = useParams();

  const [redirect, setRedirect] = useState(false);
  const [body, setBody] = React.useState();
  const [merchantName, setMerchantName] = React.useState(null);
  const [showModal, setShowModal] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [isEmptyTerms, setIsEmptyTerms] = React.useState(false);

  useEffect(() => {
    return () => abortSignal.current.abort();
  }, []);

  useEffect(() => {
    bookingApi
      .get("merchantPromos/" + id, {
        signal: abortSignal.current.signal
      })
      .then(data => {
        setBody(data);
        setMerchantName(data.merchant.name);
        if (!data.termsAndConditions) {
          setIsEmptyTerms(true);
        }
      })
      .catch(error => console.log(error));
  }, [id]);

  const handleRemove = e => {
    e.preventDefault();
    setDisabled(true);

    bookingApi
      .delete("MerchantPromos/Banner/" + id, {
        signal: abortSignal.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const handleMerchantIDChange = e => {
    setShowModal(false);
    setMerchantName(e.name);
    console.log(body);
  };

  const classes = useStyles();
  return redirect ? (
    <Redirect to={"/admin/MerchantPromo/List"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>REMOVE BANNER IMAGE</h4>
          </CardHeader>

          <CardBody>
            <p>
              <i>
                *Are you sure you want to remove the banner from this merchant
                promo?
              </i>
            </p>
            <form onSubmit={handleRemove}>
              <Button onClick={() => props.history.goBack()} value="back">
                BACK
              </Button>
              <Button
                disabled={disabled}
                color="rose"
                type="submit"
                value="Submit"
              >
                REMOVE
              </Button>
            </form>
            {body && (
              <form onSubmit={() => {}}>
                <CustomInput
                  labelText="Title"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value: body?.title ?? ""
                  }}
                />
                <CustomInput
                  labelText="Description"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value: body?.description ?? ""
                  }}
                />

                <CustomInput
                  labelText="Category"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value: body?.category ? body.category.name : ""
                  }}
                />

                <GridContainer>
                  <GridItem xs={12} sm={12}>
                    <FormControl
                      disabled
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="selAgent"
                        className={classes.selectLabel}
                      >
                        Merchant
                      </InputLabel>
                      <Input
                        disabled
                        classes={{
                          input: classes.input,
                          disabled: classes.active,
                          root: classes.active,
                          underline: classes.underline
                        }}
                        value={merchantName ?? ""}
                        onClick={() => setShowModal(true)}
                        fullWidth
                      />
                    </FormControl>
                    <MerchantDialog
                      openModal={showModal}
                      setOpenModal={val => setShowModal(val)}
                      onSelect={handleMerchantIDChange}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <p>Terms And Conditions</p>
                    </FormControl>
                  </GridItem>
                </GridContainer>
                {isEmptyTerms ? (
                  <GridItem xs={12} md={12}>
                    <div style={{ borderBottom: "1px solid #d6d6d6" }}>
                      <RichTextComponent
                        disable={true}
                        onChange={() => {}}
                        isCreate={true}
                        value={
                          body?.termsAndConditions != null &&
                          body?.termsAndConditions != ""
                            ? deserializeHtmlString(body.termsAndConditions)
                            : null
                        }
                      />
                    </div>
                  </GridItem>
                ) : (
                  body?.termsAndConditions &&
                  body?.termsAndConditions != "" && (
                    <GridItem xs={12} md={12}>
                      <div style={{ borderBottom: "1px solid #d6d6d6" }}>
                        <RichTextComponent
                          disable={true}
                          onChange={() => {}}
                          value={
                            body?.termsAndConditions != null
                              ? deserializeHtmlString(body.termsAndConditions)
                              : null
                          }
                        />
                      </div>
                    </GridItem>
                  )
                )}
                <CustomInput
                  labelText="Banner"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value: body?.banner ?? ""
                  }}
                />
                <CustomInput
                  labelText="Limit"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    type: "number",
                    value: body?.limit ?? ""
                  }}
                />
                <CustomInput
                  labelText="Claimable Limit"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    type: "number",
                    value: body?.claimableLimit ?? ""
                  }}
                />
                <CustomInput
                  labelText="Usage per user"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    type: "number",
                    value: body?.usagePerUser ?? ""
                  }}
                />
                <GridContainer>
                  <GridItem xs={12} sm={6} md={6}>
                    <FormControl fullWidth disabled>
                      <Datetime
                        disabled
                        value={new Date(body.effectiveDate + "Z")}
                        timeFormat={true}
                        closeOnSelect={true}
                        inputProps={{
                          placeholder: "Effective Date (UTC)"
                        }}
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <FormControl fullWidth disabled>
                      <Datetime
                        disabled
                        value={new Date(body.expiryDate + "Z")}
                        timeFormat={true}
                        closeOnSelect={true}
                        inputProps={{
                          placeholder: "Expiry Date (UTC)"
                        }}
                      />
                    </FormControl>
                  </GridItem>
                </GridContainer>
                <CustomInput
                  labelText="Usage Period Calculation Type"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value:
                      body.usagePeriodCalculationType != null
                        ? usagePeriodCalculation[
                            body.usagePeriodCalculationType
                          ]
                        : ""
                  }}
                />
                {body && body.usagePeriodCalculationType == 0 ? (
                  <GridContainer>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Validity Type"
                        formControlProps={{
                          fullWidth: true
                        }}
                        disabled
                        inputProps={{
                          value:
                            body.usageValidityType != null
                              ? merchantPromoValidityType[
                                  body.usageValidityType
                                ]
                              : ""
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Validity"
                        formControlProps={{
                          fullWidth: true
                        }}
                        disabled
                        inputProps={{
                          type: "number",
                          value:
                            body.usageValidity != null ? body.usageValidity : ""
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                ) : (
                  body &&
                  body.usagePeriodCalculationType == 1 && (
                    <GridContainer>
                      <GridItem xs={12} sm={6} md={6}>
                        <FormControl fullWidth disabled>
                          <Datetime
                            disabled
                            value={new Date(body.usageEffectiveDate + "Z")}
                            timeFormat={true}
                            closeOnSelect={true}
                            inputProps={{
                              placeholder: "Usage Effective Date (UTC)"
                            }}
                          />
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={6} md={6}>
                        <FormControl fullWidth disabled>
                          <Datetime
                            disabled
                            value={new Date(body.usageExpiryDate + "Z")}
                            timeFormat={true}
                            closeOnSelect={true}
                            inputProps={{
                              placeholder: "Usage Expiry Date (UTC)"
                            }}
                          />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  )
                )}

                <CustomInput
                  labelText="Type"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value: body.type != null ? merchantPromoType[body.type] : ""
                  }}
                />
                {body && body.type === 1 && (
                  <CustomInput
                    labelText="Generation Event"
                    formControlProps={{
                      fullWidth: true
                    }}
                    disabled
                    inputProps={{
                      value:
                        body.generationEvent != null
                          ? merchantPromoGenerationEvent[body.generationEvent]
                          : ""
                    }}
                  />
                )}
                <GridContainer>
                  <GridItem xs={12}>
                    <FormControlLabel
                      disabled
                      control={
                        <Checkbox
                          checked={body.isMegaMallPromo}
                          checkedIcon={
                            <Check className={classes.checkedIcon} />
                          }
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                        root: classes.labelRoot
                      }}
                      label="Is MegaMall Promo"
                    />
                  </GridItem>
                </GridContainer>
              </form>
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

RemoveBanner.propTypes = {
  history: PropTypes.object
};
